import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import { BCMSDate, BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureCalendar(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update([ "oneTimeACHPayment", "secCode" ], "CCD Credit - Non-Consumer Credit")
    .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
    .update([ "oneTimeACHPayment", "effectiveDate" ], BCMSDate.init().nextBusinessDay())
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .update([ "effectiveDateSelectIsActive", "isActive" ], true)
    .submit();

    useEffect(() => {
        // Set a data point on the date 2 business days from today.
        let setCalendarDataPointInterval = setInterval(() => {
            const weekDays = document.querySelectorAll(".week-day");
            let foundSelected = false;

            for(let i = 0; i < weekDays.length; i++) {
                const curr = weekDays[i];
    
                if(foundSelected) {
                    if(curr.hasAttribute("data-point")) {
                        const dataPointVal = curr.getAttribute("data-point");
                        if(dataPointVal === "Selected_Next_Business_Day") {
                            foundSelected = false;
                            clearInterval(setCalendarDataPointInterval);
                            break;
                        }
                    }
                    if(!curr.classList.contains("weekend")) {
                        curr.setAttribute("data-point", "Selected_Next_Business_Day");
                        break;
                    }
                }
                if(curr.classList.contains("selected")) foundSelected = true;
            }
        }, 100);
    })

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}